import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { WSCalendarComponent } from './calendar.component';
import { OnlyAuthorizedGuard } from '@services/guards/only-authorized.guard';
import { HasPermissionGuard } from '@services/guards/has-permission.guard';
import { AccountResolverService } from "@services/resolvers/account-resolver.service";

const routes: Routes = [
  {
    path: '',
    component: WSCalendarComponent,
    canActivate: [OnlyAuthorizedGuard, HasPermissionGuard],
    resolve: {
      login: AccountResolverService
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WSCalendarRoutingModule { }
